var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bs-form',{attrs:{"props":{height:this.$store.getters.formHeight,class:'console',ref:'pform',form:{ref:'cform',upload:this.$app.url.uploadApi}},"route":_vm.route}})}
var staticRenderFns = []

export { render, staticRenderFns }